import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
const fallbackLabels = {
  inbound: "Inbound",
  outbound: "Outbound"
};
const SegmentedButton = t0 => {
  const $ = _c(8);
  const {
    label,
    direction,
    togglePreferredDirection,
    directionTo
  } = t0;
  const t1 = direction === directionTo;
  let t2;
  if ($[0] !== directionTo || $[1] !== togglePreferredDirection) {
    t2 = () => togglePreferredDirection(directionTo);
    $[0] = directionTo;
    $[1] = togglePreferredDirection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `z-10 flex-1 rounded-full p-1 outline-none ring-blue-500/50 transition-colors motion-reduce:transition-none focus-visible:ring ${direction === directionTo ? "font-bold" : "font-normal hover:bg-zinc-400/10"}`;
  let t4;
  if ($[3] !== label || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <button type="button" aria-pressed={t1} onClick={t2} className={t3}>{label}</button>;
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default function DirectionControl(t0) {
  const $ = _c(20);
  const {
    direction,
    onDirectionChange,
    directionLabels
  } = t0;
  const labelId = useId();
  const indicatorPosition = direction === "inbound" ? "translate-x-0" : "translate-x-full";
  const labels = directionLabels || fallbackLabels;
  let t1;
  if ($[0] !== labelId) {
    t1 = <h2 id={labelId} className="sr-only">Trip direction</h2>;
    $[0] = labelId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `absolute bottom-0 left-0 top-0 z-10 w-1/2 rounded-full bg-zinc-100 font-bold shadow ring-1 ring-zinc-200 transition-transform duration-150 ease-in-out motion-reduce:transition-none dark:bg-zinc-800 dark:shadow-none dark:ring-zinc-900 ${indicatorPosition}`;
  let t3;
  if ($[2] !== t2) {
    t3 = <div aria-hidden="true" className={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== direction || $[5] !== labels.inbound || $[6] !== onDirectionChange) {
    t4 = <SegmentedButton label={labels.inbound} directionTo="inbound" direction={direction} togglePreferredDirection={onDirectionChange} />;
    $[4] = direction;
    $[5] = labels.inbound;
    $[6] = onDirectionChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== direction || $[9] !== labels.outbound || $[10] !== onDirectionChange) {
    t5 = <SegmentedButton label={labels.outbound} directionTo="outbound" direction={direction} togglePreferredDirection={onDirectionChange} />;
    $[8] = direction;
    $[9] = labels.outbound;
    $[10] = onDirectionChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== labelId || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div role="group" aria-labelledby={labelId} className="relative mx-[20px] mb-2 mt-6 flex rounded-full bg-zinc-50 text-lg dark:bg-zinc-900">{t3}{t4}{t5}</div>;
    $[12] = labelId;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <div>{t1}{t6}</div>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}